// The tenant feature `announcements` (#164), as the portal learns it.
//
// Unlike the other flags (map, cms, ceremony: "unknown counts as on"), this one
// is dark on prod until cutover, so unknown counts as OFF: the Announcements
// tool is offered only once a signed-in announcer's one probe has seen the
// feature slug on a competition's tenant. The probe reads core's
// `Competition.features`; it never calls the notification subgraph, which
// refuses every announcement field while the feature is off.
import { reactive } from 'vue'
import type { Client } from '@urql/vue'
import { AnnouncementFeatureProbeDocument } from './announcementFeature.operations'

export const ANNOUNCEMENTS_FEATURE = 'announcements'

export interface AnnouncementCompetition {
  id: string
  slug: string
  name: string
}

export const announcementFeature = reactive({
  /** The probe saw the feature on for at least one competition. */
  on: false,
  /** The probe ran (once per session). */
  probed: false,
  /** The competitions whose tenant has the feature. */
  competitions: [] as AnnouncementCompetition[],
})

/** Asks once per session which competitions have announcements (announcers only). */
export async function probeAnnouncementFeature(client: Client): Promise<void> {
  if (announcementFeature.probed) return
  announcementFeature.probed = true
  try {
    const r = await client.query(AnnouncementFeatureProbeDocument, {}).toPromise()
    const list = (r.data?.competitions ?? []).filter((c) =>
      c.features.includes(ANNOUNCEMENTS_FEATURE),
    )
    announcementFeature.competitions = list.map((c) => ({ id: c.id, slug: c.slug, name: c.name }))
    announcementFeature.on = list.length > 0
  } catch {
    // Unreachable is not "on": the tool stays hidden.
  }
}

/** Test seam. */
export function resetAnnouncementFeature(): void {
  announcementFeature.on = false
  announcementFeature.probed = false
  announcementFeature.competitions = []
}
